import { useIntl, FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';

import Icon from '../../components/Icon/Icon';
import RegistrationHeader from '../../components/Header/RegistrationHeader';

import { RouteParams } from './ThankYouForRegistration.model';

import styles from './ThankYouForRegistration.module.scss';

import { WORDPRESS_DOMAIN } from '../../Helpers/EnvVars';

const ThankYouForRegistration = () => {
	const { applicationType } = useParams<RouteParams>();

	const intl = useIntl();

	const getPageSubtitle = () => {
		let id;
		switch(applicationType) {
			case 'mentee-application':
				id ='thankYouForRegistration.menteeApplication.subtitle';
				break;
			case 'mentor-application':
				id = 'thankYouForRegistration.mentorApplication.subtitle';
				break;
			case 'applicant-mentee-application':
				id = 'thankYouForRegistration.applicantMenteeApplication.subtitle';
				break;
			default:
				id = 'thankYouForRegistration.mentorApplication.subtitle';
		}

		return intl.formatMessage({ id }, { b: (...chunks: any) => <b><i>{chunks}</i></b>, br: <br />, });
	}

	const getPageTitle = () => {
		let id;
		switch(applicationType) {
			case 'interrupted-application':
				id = 'thankYouForRegistration.interruptedApplication.title';
				break;
			case 'mentee-application':
				id ='thankYouForRegistration.menteeApplication.title';
				break;
			case 'mentor-application':
				id = 'thankYouForRegistration.mentorApplication.title';
				break;
			case 'newsletter-application':
					id = 'thankYouForRegistration.newsletterApplication.title';
					break;
			case 'applicant-mentee-application':
				id = 'thankYouForRegistration.applicantMenteeApplication.title';
				break;
			default:
				id = 'thankYouForRegistration.mentorApplication.title';
		}

		return intl.formatMessage({ id }, { b: (...chunks: any) => <b><i>{chunks}</i></b>, br: <br />, });
	}

	return (
		<div className={styles.pageWrapper}>
			<div className={styles.pageContainer}>

				<div className={styles.pageContent}>

					<RegistrationHeader/>

					<div className={styles.content}>
						<div className={styles.icon}><Icon name="check-circle"/></div>
						<h1>{getPageTitle()}</h1>
						{['mentee-application', 'mentor-application', 'applicant-mentee-application'].includes(applicationType) && <div className={styles.message}>{getPageSubtitle()}</div>}
						<div className={styles.contactUs}><FormattedMessage id="thankYouForRegistration.contactUs" /> <a href="mailto: info@lindau-nobel.org">info@lindau-nobel.org</a>.</div>
					</div>
					<a className={styles.link} href={WORDPRESS_DOMAIN}><FormattedMessage id="thankYouForRegistration.link"/></a>
				</div>
				<div className={styles.pageSider}></div>
			</div>
		</div>
	);
}

export default ThankYouForRegistration;